module.exports = __webpack_public_path__ + "img/ads_nophoto_tractor.9dcf1d43.png";